import { useAuth } from '../../context/AuthContext';

function LocationFilter({ userRole, locationFilter, setLocationFilter, locations }) {
  const { userInfo } = useAuth();
  const is_single_user = userInfo?.is_single_user;

  if (!['super_admin', 'docent'].includes(userRole)) return null;
  if (is_single_user) return null;

  return (
    <div className="form-group mb-3 position-relative d-inline-block">
      <label htmlFor="locationFilter" className="me-2">
        Filter op Locatie:
      </label>
      <select
        id="locationFilter"
        value={locationFilter}
        onChange={(e) => setLocationFilter(e.target.value)}
        className="form-select"
      >
        <option value="all">Toon alles</option>
        <option value="none">Zonder locatie</option>
        {locations.map((loc) => (
          <option key={loc.location_id} value={loc.location_id}>
            {loc.customer_location_number} — {loc.location_name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LocationFilter;